import { render, staticRenderFns } from "./seekerLayout.vue?vue&type=template&id=dc24c01a&scoped=true"
import script from "./seekerLayout.vue?vue&type=script&lang=js"
export * from "./seekerLayout.vue?vue&type=script&lang=js"
import style0 from "./seekerLayout.vue?vue&type=style&index=0&id=dc24c01a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc24c01a",
  null
  
)

export default component.exports